// eslint-disable-next-line spaced-comment
export default ({ size } = {}) => /*html*/`
<svg width="${ size }" height="${ size }" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.12703 6.9352L2.86082 12.2257C2.49683 12.5914 1.90825 12.5914 1.54814 12.2257L0.673016 11.3466C0.309027 10.9809 0.309027 10.3896 0.673016 10.0278L4.40583 6.27778L0.673015 2.52772C0.309027 2.16205 0.309027 1.57075 0.673015 1.20897L1.54814 0.329807C1.91212 -0.035862 2.5007 -0.0358621 2.86082 0.329807L8.12703 5.62035C8.49102 5.97824 8.49102 6.56953 8.12703 6.9352Z" fill="#595959"/>
</svg>
`
